var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLibya(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_759_6757)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.19072 6.78262C0.427875 8.36025 0 10.1301 0 12C0 13.8699 0.427875 15.6397 1.19072 17.2174L12 18.2609L22.8093 17.2174C23.5721 15.6397 24 13.8699 24 12C24 10.1301 23.5721 8.36025 22.8093 6.78262L12 5.73914L1.19072 6.78262Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.19114 17.2174C3.13205 21.2313 7.24247 24 12 24C16.7575 24 20.868 21.2313 22.8089 17.2174H1.19114Z",
    fill: "#496E2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.19114 6.78263H22.8089C20.868 2.76867 16.7575 0 12 0C7.24247 0 3.13205 2.76867 1.19114 6.78263Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7931 9.80557L15.7777 11.1624L17.3722 10.6453L16.386 12.001L17.3705 13.3577L15.7766 12.8387L14.7904 14.1943L14.7915 12.518L13.1974 11.999L14.792 11.482L14.7931 9.80557Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.106 15.3913C10.233 15.3913 8.71467 13.8729 8.71467 12C8.71467 10.127 10.233 8.60867 12.106 8.60867C12.69 8.60867 13.2395 8.75633 13.7192 9.0163C12.9666 8.28032 11.9374 7.82605 10.8016 7.82605C8.49642 7.82605 6.62775 9.69477 6.62775 11.9999C6.62775 14.3051 8.49647 16.1738 10.8016 16.1738C11.9374 16.1738 12.9666 15.7196 13.7192 14.9836C13.2394 15.2436 12.69 15.3913 12.106 15.3913Z",
    fill: "#F0F0F0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_759_6757"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLibya);
export default __webpack_public_path__ + "static/media/libya.7a88ca5f2f68b3ba09de69ddc1b24d5c.svg";
export { ForwardRef as ReactComponent };